module.exports = __webpack_public_path__ + "img/market-banner__bg.png?246d8a0bfed83aec8808defe12de7adf";